import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import fCenterMessage from '@/components/fCenterMessage';
import { FI18n, FUtil } from '@freelog/tools-lib';
import img_cover from './loginCover.png';
import img_logo from './freelog.png';
import FModal from '@/components/FModal';
import FPasswordInput from '@/components/FPasswordInput';
import { Helmet } from 'umi';
import dayjs from 'dayjs';

interface GuideFreelogProps {}

function GuideFreelog({}: GuideFreelogProps) {
  const [cookie, setCookie] = AHooks.useCookieState('guideFreelog');

  const [$modalOpen, set$modalOpen, get$modalOpen] = FUtil.Hook.useGetState<boolean>(false);
  const [$modalPassword, set$modalPassword, get$modalPassword] = FUtil.Hook.useGetState<string>('');

  return (
    <>
      <Helmet>
        <title>{`Freelog`}</title>
      </Helmet>
      <div className={styles.container}>
        <img src={img_cover} className={styles.cover} alt={''} />
        <div className={styles.guide}>
          <div />
          <div className={styles.box}>
            <img
              src={img_logo}
              style={{ width: 180, opacity: 0.6 }}
              alt={''}
              // className={styles.logo}
            />
            <div style={{ height: 50 }} />
            {/*<FComponentsLib.FTitleText type={'h1'} text={'目前您在测试环境，现在去正式环境'} />*/}
            <div className={styles.tip}>点击按钮，访问freelog</div>
            <div style={{ height: 50 }} />
            <FComponentsLib.FRectBtn
              style={{
                width: 200,
                height: 60,
                fontSize: 14,
                color: '#fff',
                lineHeight: '20px',
              }}
              onClick={() => {
                self.location.replace('https://www.freelog.cn');
              }}
            >
              进入freelog平台
            </FComponentsLib.FRectBtn>
            {/*<div style={{ height: 100 }} />*/}
            {/*<div style={{ width: 300 }}>*/}

            {/*</div>*/}
          </div>
          <FComponentsLib.FTextBtn
            type={'default'}
            style={{ fontSize: 12 }}
            onClick={() => {
              set$modalOpen(true);
            }}
          >
            访问测试环境
          </FComponentsLib.FTextBtn>
        </div>

        <FModal
          // title={null}
          // footer={null}
          open={$modalOpen}
          width={500}
          centered={true}
          onCancel={() => {
            set$modalOpen(false);
          }}
        >
          <div className={styles.modal}>
            {/*<div className={styles.title}>输入内部密码</div>*/}
            <div className={styles.title}>
              {FI18n.i18nNext.tAuto('testfreelog_welcome_continue_title')}
            </div>
            <div style={{ height: 60 }} />
            <FPasswordInput
              value={$modalPassword}
              onChange={(e) => {
                set$modalPassword(e.target.value);
              }}
              style={{ width: 360 }}
              // placeholder={'输入内部密码'}
              placeholder={FI18n.i18nNext.t('testfreelog_welcome_continue_input_hint')}
              // onPressEnter={((value: any) => {
              //
              // })}
            />
            <div style={{ height: 70 }} />
            <div className={styles.footer}>
              <FComponentsLib.FTextBtn
                onClick={() => {
                  set$modalOpen(false);
                }}
                type={'default'}
              >
                {/*取消*/}
                {FI18n.i18nNext.tAuto('testfreelog_welcome_continue_btn_cancel')}
              </FComponentsLib.FTextBtn>
              <FComponentsLib.FRectBtn
                type={'primary'}
                onClick={() => {
                  if (
                    get$modalPassword() !== dayjs().format('YYYYMMDD').split('').reverse().join('')
                  ) {
                    fCenterMessage({ message: '密码错误' });
                    return;
                  }
                  setCookie('false', {
                    domain: FUtil.Domain.getHostMatchedPublicSuffix(),
                    path: '/', // cookie 的路径
                    // expires: new Date('2099-12-31T23:59:59.000Z'),
                    expires: dayjs().add(1, 'month').toDate(),
                    // expires: Date.now() * 2,
                    secure: true,
                  });
                  self.location.replace(FUtil.LinkTo.home());
                }}
              >
                {/*访问测试环境*/}
                {FI18n.i18nNext.tAuto('testfreelog_welcome_continue_btn_enter')}
              </FComponentsLib.FRectBtn>
            </div>
          </div>
        </FModal>
      </div>
    </>
  );
}

export default GuideFreelog;
